<div class="i18n-disclaimer" *ngIf="!(hidden | async)">
  <div (click)="hide()" class="close">&times;</div>
  <div class="title">The version of kozikaza.com that you are looking at is not optimized for your country.</div>
  <div class="message">To see a more appropriate version, log in or create an account. Please note, some pages and features may no longer appear after you log in.</div>
</div>
